// extracted by mini-css-extract-plugin
module.exports = {"companyLogo":"AtExhibitingCompanyLogo_companyLogo__3XytN"};